import React, { useState } from 'react';
import TermSkeleton from './Term/TermSkeleton';

const Privacy = () => {
        const [isLoaded, setIsLoaded] = useState(false);
    
        const handleLoad = () => {
            setIsLoaded(true);
        };
    return (

        <>
            {!isLoaded && <TermSkeleton />}
            <iframe
                className="term"
                src="https://zeely.app/privacyContent.html"
                frameBorder="0"
                onLoad={handleLoad}
                style={{ display: isLoaded ? "block" : "none" }}
            ></iframe>
        </>

    );
}

export default Privacy;
